import React, { useRef, useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import "./ServicesWeProvide.scss";

const CARD_WIDTH = 300;
const GAP = 24;
const VISIBLE_CARDS = 3.5;

const ServicesWeProvide = ({ services = [] as any[] }) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [scrollIndex, setScrollIndex] = useState(0);

  const totalCards = services.length;
  const maxScrollIndex = Math.max(0, Math.ceil(totalCards - VISIBLE_CARDS));

  const handleScroll = (direction: "left" | "right") => {
    if (!scrollRef.current) return;

    const newIndex =
      direction === "right"
        ? Math.min(scrollIndex + 1, maxScrollIndex)
        : Math.max(scrollIndex - 1, 0);

    const scrollAmount = (CARD_WIDTH + GAP) * newIndex;
    scrollRef.current.scrollTo({
      left: scrollAmount,
      behavior: "smooth",
    });

    setScrollIndex(newIndex);
  };

  return (
    <Box className="services-we-provide-section">
      {/* Subtitle */}
      <Typography className="services-we-provide-section__subtitle">
        <span className="services-we-provide-section__subtitle--bold">
          Services
        </span>{" "}
        <span className="services-we-provide-section__subtitle--light">
          We Provide
        </span>
      </Typography>

      <Typography className="services-we-provide-section__description">
        We provide a complete range of services to support families with care
        and compassion, including peaceful cemeteries, simple and dignified
        direct burials, affordable direct cremations, and welcoming funeral
        homes designed for meaningful farewells. Our memorial services honor
        cherished memories, while grief support resources offer comfort during
        difficult times. For those who wish to plan ahead, our pre-planning
        options ensure peace of mind, and our traditional funeral services
        preserve time-honored customs with respect and grace.
      </Typography>

      {/* Carousel */}

      {services.length > 0 && (
        <Box className="services-we-provide-section__carousel-wrapper">
          {/* Left Button */}
          <IconButton
            className="services-we-provide-section__carousel-btn services-we-provide-section__carousel-btn--left"
            onClick={() => handleScroll("left")}
            disabled={scrollIndex === 0}
          >
            <ArrowBackIosNewIcon fontSize="small" />
          </IconButton>

          <Box
            className="services-we-provide-section__carousel"
            ref={scrollRef}
          >
            {services.map((service, index) => (
              <Box
                key={service.id || index}
                className="services-we-provide-section__carousel-card"
              >
                <img
                  src={`https://media.gettyimages.com/id/104302974/photo/people-at-a-funeral.jpg?s=1024x1024&w=gi&k=20&c=ItRTvwQ4A8Pv6KstxoUX60IwNfww4cU8yH7QLkJkqRE=`}
                  alt={service.name}
                  className="services-we-provide-section__carousel-card-image"
                />
                <Typography className="services-we-provide-section__carousel-card-title">
                  {service.name}
                </Typography>
              </Box>
            ))}
          </Box>

          {/* Right Button */}
          <IconButton
            className="services-we-provide-section__carousel-btn services-we-provide-section__carousel-btn--right"
            onClick={() => handleScroll("right")}
            disabled={scrollIndex === maxScrollIndex}
          >
            <ArrowForwardIosIcon fontSize="small" />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};

export default ServicesWeProvide;
